import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const getKatlasStatus = () => http.get("/katlas/status").then((r) => r.data);
export const listRequests = () => http.get("/requests").then((r) => r.data);
export const getRequest = (id) => http.get(`/requests/${id}`).then((r) => r.data);
export const validateRequest = (id) =>
    http.post(`/requests/${id}/validate`).then((r) => r.data);
export const signRequest = (id) => http.post(`/requests/${id}/sign`).then((r) => r.data);
export const getReceipt = (hash) => http.get(`/receipts/${hash}`).then((r) => r.data);
export const getDiagnostics = () => http.get("/diagnostics").then((r) => r.data);

export const getCAElection = (id) => http.get(`/ca/elections/${id}`).then((r) => r.data);
export const validateCAElection = (id, repaired = false) =>
    http.post(`/ca/elections/${id}/validate`, null, { params: { repaired } }).then((r) => r.data);
export const repairCAElection = (id) =>
    http.post(`/ca/elections/${id}/repair`).then((r) => r.data);
export const signCAElection = (id, repaired = false) =>
    http.post(`/ca/elections/${id}/sign`, null, { params: { repaired } }).then((r) => r.data);

// --- Live control plane (authoritative engine, /api/control) ---------------
export const getControlManifest = () => http.get("/control/manifest").then((r) => r.data);
export const listInstructions = () => http.get("/control/instructions").then((r) => r.data);
export const createJourney = (body) => http.post("/control/journeys", body).then((r) => r.data);
export const readJourney = (id) => http.get(`/control/journeys/${id}`).then((r) => r.data);
export const evaluateJourney = (id, expected_version) =>
    http.post(`/control/journeys/${id}/evaluate`, { expected_version }).then((r) => r.data);
export const repairJourney = (id, body, roleSession) =>
    http.post(`/control/journeys/${id}/repair`, body,
        { headers: { "X-Role-Session": roleSession } }).then((r) => r.data);
export const reevaluateJourney = (id, expected_version) =>
    http.post(`/control/journeys/${id}/reevaluate`, { expected_version }).then((r) => r.data);
export const executeAdapter = (journey_id, authorisation) =>
    http.post("/control/adapter/execute", { journey_id, authorisation }).then((r) => r.data);

export const createLiveElection = (body) => http.post("/control/ca/elections", body).then((r) => r.data);
export const readLiveElection = (id) => http.get(`/control/ca/elections/${id}`).then((r) => r.data);
export const evaluateLiveElection = (id, expected_version) =>
    http.post(`/control/ca/elections/${id}/evaluate`, { expected_version }).then((r) => r.data);
export const repairLiveElection = (id, body, roleSession) =>
    http.post(`/control/ca/elections/${id}/repair`, body,
        { headers: { "X-Role-Session": roleSession } }).then((r) => r.data);
export const reevaluateLiveElection = (id, expected_version) =>
    http.post(`/control/ca/elections/${id}/reevaluate`, { expected_version }).then((r) => r.data);
export const readElectionReceipt = (id) =>
    http.get(`/control/ca/elections/${id}/receipt`).then((r) => r.data);
